//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { getCountryPageInformation } from '~/utils/server'
import FaqItems from '~/components/Flotillas/FaqItems'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import flotilla from '~/mixins/page/flotilla'
import { getFlag } from '~/utils/languages'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import RequestBoatModal from '~/components/modal/boat/request-boat-modal'
import RequestOfferForm from '~/components/form/user/request-offer-form'
import { asyncDataStart } from '~/utils/asyncData'

export default {
  name: 'FlotillaPage',
  components: {
    FaqItems,
    RequestBoatModal,
    RequestOfferForm
  },
  filters: {
    formattedDate (inDate, inFormat, outFormat) {
      const t = inDate.split('-')
      if (t.length === 3) {
        return t[2] + '/' + t[1] + '/' + t[0]
      } else {
        return inDate
      }
    },
    resizeImageUrl (url, width, height) {
      let result = `${url}`
      if (result.match(/&w=\d*/)) {
        result = result.replace(/&w=\d*/, `&w=${width}`)
      } else {
        result += `&w=${width}`
      }
      if (result.match(/&h=\d*/)) {
        result = result.replace(/&h=\d*/, `&h=${height}`)
      } else {
        result += `&h=${height}`
      }
      result = result.replace(/&rect=(\d+(,\d+)*)/, '')
      return result
    }
  },
  mixins: [pageMeta, flotilla],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    const ietfLocale = ctx.store.getters['lang/currentLanguage']?.ietf_locale
    let lang = ctx.store.getters['lang/locale']
    let ietf = ietfLocale || 'en-gb'

    if (lang === 'us') {
      lang = 'en'
      ietf = 'en-gb'
    }
    const country = ctx.route.params.country

    const countryInformation = await getCountryPageInformation(ctx, { lang, ietf, countryName: country })

    if (!countryInformation.country_title) {
      ctx.redirect(301, ctx.app.router.resolve({ name: 'flotilla page', params: {lang: 'en'} }).href)
      return
    }

    await mxGetMeta(ctx, {
      meta: {
        idx: countryInformation.uid || 'empty',
        method: 'dynamic',
        type: country ? 'flotilla_country' : 'flotilla_overview',
        path: ctx.route.path
      }
    })

    const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [
      {
        title: ctx.app.i18n.t('flotillas'),
        url: ctx.app.router.resolve({ name: 'flotillas', params: { lang: ctx.store.getters['lang/locale'] } }).href
      },
      {
        title: countryInformation.uid,
        url: ctx.route.fullPath
      }
    ])
    await ctx.store.dispatch('setBreadcrumbs', crubms)

    return { countryInformation, country }
  },
  computed: {
    getSliderImages () {
      const result = [...this.countryInformation.image_slider]
      result.push(result.shift())
      return result.map((i) => {
        return {
          ...i.slider_image
        }
      })
    },
    currentImageUrl () {
      return this.getSliderImages[this.currentSlide]?.hero?.url || ''
    },
    ...mapState({
      pageSeoData: state => state.pageData,
      lang: state => state.lang.locale
    }),
    getSliderSettings: app => (name) => {
      const SETTINGS = {
        main: {
          slidesToShow: 1,
          arrows: false,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                dots: true
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                dots: true,
                arrows: true
              }
            }
          ]
        }
      }
      return {
        settings: {
          type: 'slider',
          arrows: false,
          gaps: {
            value: 24
          }
        },
        ...SETTINGS[name]
      }
    }
  },
  methods: {
    nextSlide () {
      if (this.currentSlide + 1 < this.countryInformation?.image_slider.length) {
        this.currentSlide += 1
      }
    },
    prevSlide () {
      if (this.currentSlide >= 1) {
        this.currentSlide -= 1
      }
    },
    getFlag (name) {
      return getFlag(name)
    },
    setSticky (isVisible, entry) {
      this.page.sticky = !isVisible
    },
    scrollToElement ($element) {
      const offset = 100
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = document.getElementById($element).getBoundingClientRect().top
      const elementPosition = elementRect - bodyRect
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  },
  data () {
    return {
      currentSlide: 0,
      page: {
        sticky: false
      }
    }
  }
}
